var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c("div", { staticClass: "both-pd-box1" }, [
      _c(
        "div",
        {
          staticStyle: {
            background: "#fff",
            padding: "10px 30px",
            "border-radius": "20px",
          },
        },
        [
          _c("h3", [_vm._v("转链弹窗-抖音非高佣下单快捷入口")]),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("div", { staticClass: "tips" }, [
                _vm._v(
                  "打开后，抖音高佣商品的剪切板弹窗，会提供非高佣的下单入口"
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "demo-form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "200px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "抖音高佣下单入口:", prop: "radio" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.radio,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "radio", $$v)
                            },
                            expression: "form.radio",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("打开"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("关闭"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSubmit },
                        },
                        [_vm._v("\n              保存\n            ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }